import React from "react";
import { motion } from "framer-motion";
import Bullrun from "../components/images/bullrun.png";

const Tokenomics: React.FC = () => {
  const tokenSupply = "500,000,000,000"; // Update this if needed

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // Stack items vertically on smaller screens
        justifyContent: "space-between",
        alignItems: "center", // Center items for better alignment
        backgroundColor: "#1e1e1e", // Dark background for contrast
        borderRadius: "20px",
        padding: "30px", // More padding for a neater look
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)", // Subtle shadow
        maxWidth: "1200px", // Limit width for better readability
        margin: "20px auto", // Centering the content
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{ flex: 1, marginRight: "20px", textAlign: "center" }} // Center text
      >
        <h1
          style={{
            fontFamily: "'Psychedelic Font', cursive",
            color: "#ff007f",
            textAlign: "center",
            textShadow: "2px 2px 5px rgba(255, 0, 127, 0.7)", // Text shadow for depth
          }}
        >
          Tokenomics
        </h1>
        <h2
          style={{
            fontSize: "2rem",
            color: "#ffffff", // White text for contrast
            textAlign: "center",
          }}
        >
          Total Token Supply: {tokenSupply}
        </h2>
        <p
          style={{
            fontSize: "1.2rem",
            color: "#ffffff", // White text for contrast
            lineHeight: "1.6", // Increased line height for readability
          }}
        >
          Welcome to the Methereum revolution! With a total supply of
          <strong> {tokenSupply} METH</strong>, our token is designed for
          everyone—no hidden fees or complicated rules.
        </p>
        <p
          style={{
            fontSize: "1.2rem",
            color: "#ffffff", // White text for contrast
            lineHeight: "1.6", // Increased line height for readability
          }}
        >
          Our liquidity tokens are burned, and contract ownership has been
          renounced to ensure that $METH is truly a coin for the community. It’s
          not just a meme; it’s your meme. Get ready for a token experience that
          puts power back in your hands!
        </p>
      </motion.div>

      {/* Image on the right side */}
      <img
        src={Bullrun}
        alt="An illustration depicting the Methereum journey" // More descriptive alt text
        style={{
          borderRadius: "20px",
          margin: "20px 0",
          paddingTop: "50px",
          height: "300px",
          width: "300px",
          maxWidth: "100%", // Make the image responsive
          objectFit: "contain", // Ensure the aspect ratio is maintained
        }}
      />
    </div>
  );
};

export default Tokenomics;
